import { Field } from "../Field/field"
import { ModulesManagerService } from "../Module/modules-manager.service"
import { Ask } from "../Ask/ask.service"
import * as Leaflet from 'leaflet';
import * as ELG from 'esri-leaflet-geocoder';

//https://developers.arcgis.com/esri-leaflet/geocode-and-search/search-for-an-address/

export class GeolocationField extends Field {
    private map: Leaflet.Map;
    private layer: Leaflet.TitleLayer;
    private searchControl: any;
    private marker: Leaflet.Marker;
    private died = false;
    constructor( manager :ModulesManagerService, Data= null){    
        super(manager, Data)
        //this.geoCoder = (new Esri.Geocoding.Geocode({apikey: 'AAPK59a4b6b087124726952d60fb795e0b5562S3sZMEaNkGc8fSrBuTqvk8JpJnqDgxuSUYwEQEKJjaQS5_CoHLVpmEeHmAdYLq'}))
        Leaflet.Icon.Default.imagePath = "assets/leaflet/" // on change le chemin de l'image par défaut de leaflet
    }
    
    /** @override */
    isActive(): boolean {
        return this.needToRenderView() && (!this.currentAsk?.getField({TargetField: "ShowGeolocation"}) || this.currentAsk?.getField({TargetField: "ShowGeolocation"})?.Value )  
    }

    /** @override */
    async OnHydrated(){
        if(typeof this.Value == "string"){
            super["value"]= this.manager.Tool.jsonParse( this.Value, null, true)           
        }
        
        if(!this.needToRenderView() || this.map==null) return
        await this.setMarker()
        await super.OnHydrated()
    }

    /** @override */
    get DivId(){
        return "geolocation"+this.askId
    }

    needToRenderView(): boolean {
        return !this.died       
    }

    private async mouveMarker(e){        
        this.Value={
            lat: e.latlng.lat,
            lng: e.latlng.lng
        }
        await this.setMarker()
    }
    
    private async defineMap(){
        /// si on a déjà la map alors return avant tous
        if(!this.needToRenderView() || this.map!=null) return
        if(typeof this.Value == "string"){
            super["value"]= this.manager.Tool.jsonParse( this.Value, null)
        }
        if(this.Id<=0 && (!this.Value || !(this.Value.lat ||  this.Value.lng))){
            /* 
                ici c'est hard faut pas faire ca mais je veut pas ouvrire un setter qui ne vérifie pas la perm d'édition donc je le force et ca marche
                ailleur merci de respecter le setter this.Value = value comme fais dans la fonction mouveMarker
            */ 
            super["value"]= await this.manager.getGeolocation()            
        }        
        this.map = Leaflet.map(this.DivId).setView([this.Value?.lat, this.Value?.lng], 5);     
        this.layer =Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        })
        this.layer.addTo(this.map);
        this.addSearchLeayer()
        await this.setMarker()
        this.map.invalidateSize();   
        this.map.on('click', e=>this.mouveMarker(e))
    }

    private addSearchLeayer() {
        this.searchControl = ELG.geosearch({
            useMapBounds: false,
            placeholder: this.manager.Trad.Parse("STR_ENTER_ADDRESSE"),
            position: "topright",
            providers: [
              ELG.arcgisOnlineProvider({
                apikey: "AAPK59a4b6b087124726952d60fb795e0b5562S3sZMEaNkGc8fSrBuTqvk8JpJnqDgxuSUYwEQEKJjaQS5_CoHLVpmEeHmAdYLq"
              })
            ]
          });
          
        this.searchControl.addTo(this.map);
        this.searchControl.on('results',e=>this.mouveMarker(e))
    }

    async setMarker( ){
        if(this.Value && (this.Value.lat || this.Value.lng)){
            this.cleanMarker()
            this.marker = Leaflet.marker([this.Value.lat, this.Value.lng]).addTo(this.map);
            //await this.map.setView([this.Value.lat, this.Value.lng], 15);
            await this.map.fitBounds([[this.Value.lat, this.Value.lng],[this.Value.lat, this.Value.lng]])
        }
    }

    private cleanMap(){
        this.map?.off()
        this.map?.remove()
        this.map = null
    }

    private cleanMarker(){
        this.marker?.remove()
        this.marker = null
    }

    private clean(){
        this.cleanMap()
        this.cleanMarker()
    }

    async leafletMap(){
        while(this.needToRenderView()){
            await this.manager.Tool.sleep(150)
            if(!this.isActive()){
                this.clean()
                continue;
            }
            while( this.manager.getElementsBy("Id", this.DivId).length == 0 && this.needToRenderView()) await this.manager.Tool.sleep(1) // on attend la vue de la carte
            await this.defineMap()
            if(this.canEdit){
                this.searchControl?.enable()
            }else{                
                this.searchControl?.disable()
            }
        }
        this.clean()
    }

    /** @override */
    async postRenderHtml(ask: Ask, ...args: any[]) : Promise<any> {
        super.postRenderHtml(ask, ...args)
        this.died=false
        this.clean()
        this.leafletMap()
    }

    /** @override */
    async Destroy() : Promise<any> {
        this.died = true
        this.clean()
    }
}
